import { IoMdRefresh } from "react-icons/io";
import PropTypes from "prop-types";

const ResetIcon = ({
  onClick,
  size,
  sx,
  className,
  title,
  hidden,
  disabled,
}) => {
  return (
    <IoMdRefresh
      className={`${className} no-shrink`}
      size={size}
      onClick={onClick}
      style={sx}
      title={title}
      hidden={hidden}
      disabled={disabled}
    />
  );
};

ResetIcon.defaultProps = {
  size: 30,
  onClick: () => {},
  sx: {},
  className: "",
  title: "Reset",
  hidden: false,
  disabled: false,
};

ResetIcon.propTypes = {
  onClick: PropTypes.func,
  size: PropTypes.number,
  sx: PropTypes.object,
  className: PropTypes.string,
  title: PropTypes.string,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
};
export default ResetIcon;
